import type {
  FetchUserNotificationsParams,
  NotificationsQueryKey,
  NotificationsQuerySuffix,
  UseGetUserNotificationsProps,
} from "./notifications.type";
import type { NotificationEntity } from "@/entities/notification";

import { client } from "@/config/client";
import { useInfiniteListWrapper } from "@/hooks/queries";

import { NOTIFICATIONS_PER_PAGE } from "./notifications.constant";

const fetchUserNotifications = (params: FetchUserNotificationsParams) => {
  const finalPrams: FetchUserNotificationsParams = {
    ["page[size]"]: NOTIFICATIONS_PER_PAGE,
    ...params,
  };

  return client.user.notifications.list(finalPrams);
};

export const useGetUserNotifications = ({
  readState,
  queryKeySuffix,
}: UseGetUserNotificationsProps = {}) => {
  const suffix: NotificationsQuerySuffix = queryKeySuffix ?? readState ?? "all";
  const queryKey: NotificationsQueryKey = ["notifications", suffix];

  const { data, ...queryResult } = useInfiniteListWrapper<NotificationEntity>({
    queryKey,
    queryFn: ({ pageParam = 1 }) =>
      fetchUserNotifications({
        "page[number]": pageParam,
        "filter[read_state]": readState,
      }),
  });

  return {
    notifications: data ?? [],
    ...queryResult,
  };
};

export const useGetNotificationsUnreadCount = () => {
  const { notifications, isLoading } = useGetUserNotifications({
    readState: "unread",
    queryKeySuffix: "unread_count",
  });

  return {
    unreadCount: notifications.length,
    isLoading,
  };
};
